import { useMemo } from 'react';

const useGroupingData = ({ data, groupBy }) => {
  return useMemo(() => {
    return data?.reduce((prev, current) => {
      const id = prev.findIndex((item) => item.title === current[groupBy]);
      id >= 0
        ? prev[id].items.push(current)
        : prev.push({ title: current[groupBy], items: [current] });
      return prev;
    }, []);
  }, [data]);
};

export default useGroupingData;
